// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_93444fe79c--tooltip--Rln6T","arrow":"_93444fe79c--arrow--GMnRq"};